import React from 'react';

import { withRouter } from 'react-router-dom';
import 'react-table/react-table.css';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

import 'react-notifications/lib/notifications.css';

import './style.css';

class AdminSettings extends React.Component {
  render() {
    const host = () => {
      this.props.history.push('/host');
    };

    const userManagment = () => {
      this.props.history.push('/usermanagment');
    };
    const videoAccess = () => {
      this.props.history.push('/videoaccess');
    };
    return (
      <div className="row" style={{ marginTop: '20px' }}>
        <div className="admin-setting-flex">
          <div className="tile-admin-card green-admin" onClick={host}>
            <div className="icon-admin-card">
              <i className="fa fa-user" aria-hidden="true"></i>
            </div>
            <h3>Host</h3>
            <p>Host information can be modified here</p>
          </div>

          <div className="tile-admin-card orange-admin" onClick={userManagment}>
            <div className="icon-admin-card">
              <i className="fa fa-cog" aria-hidden="true"></i>
            </div>
            <h3>User Managment</h3>
            <p>External User can be added here</p>
          </div>

          <div className="tile-admin-card blue-admin" onClick={videoAccess}>
            <div className="icon-admin-card">
              <i className="fa fa-key" aria-hidden="true"></i>
            </div>
            <h3>Member Video Access</h3>
            <p>Member video access can be granted</p>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AdminSettings);
